"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TractableTheme = exports.GlobalStyles = exports.useTractableTheme = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@emotion/react");
var ThemeProvider_1 = require("./ThemeProvider");
var ThemeProvider_2 = require("./ThemeProvider");
Object.defineProperty(exports, "useTractableTheme", { enumerable: true, get: function () { return ThemeProvider_2.useTractableTheme; } });
var GlobalStyles = function (props) {
    return (0, jsx_runtime_1.jsx)(react_1.Global, { styles: props.styles });
};
exports.GlobalStyles = GlobalStyles;
var TractableTheme = function (props) {
    var _a = props.overrides, overrides = _a === void 0 ? {} : _a, children = props.children;
    return ((0, jsx_runtime_1.jsxs)(ThemeProvider_1.TractableThemeProvider, __assign({ overrides: overrides }, { children: [(0, jsx_runtime_1.jsx)(ThemeProvider_1.TractableThemeContext.Consumer, { children: function (theme) {
                    if (!theme)
                        return false;
                    return (0, jsx_runtime_1.jsx)(exports.GlobalStyles, { styles: theme.global });
                } }), children] })));
};
exports.TractableTheme = TractableTheme;
